import { useCallback } from 'react';
import type { SecurityPermission } from '@ic/security-registry';
import { canAccess } from '@/lib/access';
import { useEffectivePermissions } from './useEffectivePermissions';

/**
 * Permission check for components that read the cached `/api/auth/effective-permissions` response
 * (React Query) rather than `useAuth().hasPermission`. Same rule as the server: a folder grant
 * covers its children. `isLoading` is true until the response arrives; the check is false meanwhile.
 */
export function useCanAccess() {
  const { data, isLoading } = useEffectivePermissions();
  const check = useCallback((permission: SecurityPermission): boolean => canAccess(data ?? null, permission), [data]);
  return { canAccess: check, isLoading };
}
